import { MeteorObservable } from 'meteor-rxjs';
import { Subscription } from 'rxjs';

/**
 * Creates a MongoDB Subscription and returns a promise which resolves when the subscription is done
 */
export async function startMeteorSubscription(
  subscriptionName: string,
  params: any = {},
): Promise<Subscription> {
  return await new Promise<Subscription>((resolve) => {
    const subscription = MeteorObservable.subscribe(
      subscriptionName,
      params,
    ).subscribe(() => {
      // timeout fixes "cannot access 'subscription' before initialization" error
      setTimeout(() => {
        resolve(subscription);
      });
    });
  });
}
